import styles from "./ClientActivitySummary.module.css";

export default function StatCard({ label, value, icon: Icon, variant }) {
  const variantClass =
    variant === "navy"
      ? styles.statCardNavy
      : variant === "amber"
        ? styles.statCardAmber
        : "";

  return (
    <div className={`${styles.statCard} ${variantClass}`}>
      <div>
        <div className={styles.statCardLabel}>{label}</div>
        <div className={styles.statCardDivider} />
        <div className={styles.statCardValue}>{value}</div>
      </div>
      <div className={styles.statCardIcon}>
        <Icon size={26} />
      </div>
    </div>
  );
}
